import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";
import { Brain } from "lucide-react";

const BehaviorAnalysis = () => {
  const { toast } = useToast();
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleBehaviorAnalysis = async (userId: number) => {
    setIsAnalyzing(true);
    try {
      toast({
        title: "Behavior Analysis Complete",
        description: "User behavior pattern analyzed successfully.",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Analysis Failed",
        description: "There was an error analyzing user behavior.",
      });
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <Card className="p-8">
      <h2 className="text-2xl font-semibold mb-6">Behavior Analysis</h2>
      <div className="space-y-6">
        <Textarea
          placeholder="Enter user behavior data for analysis..."
          className="min-h-[150px] w-full"
        />
        <Button 
          onClick={() => handleBehaviorAnalysis(1)}
          className="w-full"
          disabled={isAnalyzing}
        >
          <Brain className="mr-2 h-4 w-4" />
          Analyze Behavior Patterns
        </Button>
      </div>
    </Card>
  );
};

export default BehaviorAnalysis;